import React from 'react';
import './EntityListTab.css';
import EntityList from './EntityListTab/EntityList.jsx';
import EntityTable from './EntityListTab/EntityTable.jsx';

import Modal from '../Modal.jsx';
import queryString from 'query-string';

import CompareProp from '../CompareProp.js';
import CompareStat from '../CompareStat.js';
import { withRouter } from 'react-router-dom';

class EntityListTab extends React.Component{
    constructor(props) {
        super(props);
        let options = queryString.parse(this.props.location.search);
        // console.log(options)
        this.state = {
            entitySortProp: 'name',
            sortReverse: false,
            tagSelector: false,
            tagList: [],
            operation: 'all',
            logic: 'or',
            columnSort: options.columnSort || '',
            colSortType: parseInt(options.colSortType) || 0,
            colSortGroup: options.colSortGroup || '',
        }
    }
    fields = [
        'parent-op',
        'white-op',
        'whitelistTags',
        'black-op',
        'blacklistTags',
        'columnSort',
        'colSortType',
        'colSortGroup',
    ]
    skillGroups = [
        'none',
        'Academic',
        'Combat',
        'Espionage',
        'Social',
        'Special',
    ];
    columnSortMethods = [
        'none',
        'sort-asc',
        'sort-desc',
        'filter-asc',
        'filter-desc',
    ];
    componentDidMount = () => {
        this.pushHistory();
    }
    /**
     * Gets the intended URL params from the body options
     * @param {*} e the event
     */
    pushHistory = (e, colsort) => {
        let target = e?.target;
        // console.log(this.state)
        // console.log(e, target);
        let options = queryString.parse(this.props.location.search);
        let tagSettings = {};
        this.fields.forEach(field => {
            let value = '';
            let element = document.getElementById(field)
            if(!!element) {
                value = element.value;
            }
            else if(!!options[field]) {
                value = options[field];
            }
            tagSettings[field] = value;
        })
        tagSettings['columnSort'] = this.state.columnSort;
        tagSettings['colSortType'] = this.state.colSortType;
        tagSettings['colSortGroup'] = this.state.colSortGroup;

        // tagSettings['columnSort'] = options.columnSort;
        // tagSettings['colSortType'] = options.colSortType;
        // tagSettings['colSortGroup'] = options.colSortGroup;
        // if(!!colsort) {
        //     tagSettings['columnSort'] = colsort.columnSort;
        //     tagSettings['colSortType'] = colsort.colSortType;
        //     tagSettings['colSortGroup'] = colsort.colSortGroup;
        // }
        // console.log(options['white-op'], tagSettings['white-op']);
        tagSettings['parent-op'] = tagSettings['parent-op'] || 'doc';
        tagSettings['white-op'] = tagSettings['white-op'] || 'any';
        tagSettings['black-op'] = tagSettings['black-op'] || 'any';
        let whitelist = options.whitelistTags?.split(',') || [];
        let blacklist = options.blacklistTags?.split(',') || [];
        if(!!target) {
            let listname = target.dataset.list;
            // console.log(target.checked)
            if(target.checked) {
                if(listname === 'whitelist') {
                    whitelist.push(target.value);
                }
                if(listname === 'blacklist') {
                    blacklist.push(target.value);
                }
            }
            if(!target.checked) {
                // console.log(target.value)
                // console.log(listname)
                if(listname === 'whitelist') {
                    whitelist = whitelist.filter(x => x !== target.value);
                }
                if(listname === 'blacklist') {
                    blacklist = blacklist.filter(x => x !== target.value);
                }
            }
        }
        whitelist = whitelist.filter(x => !!x);
        blacklist = blacklist.filter(x => !!x);
        tagSettings['whitelistTags'] = whitelist.join(',');
        tagSettings['blacklistTags'] = blacklist.join(',');
        // console.log(tagSettings);
        let newSubpath = '?';
        this.fields.forEach(field => {
            newSubpath += field + '=' + tagSettings[field] + '&';
        })
        newSubpath = newSubpath.substring(0, newSubpath.length - 1);
        // console.log(newSubpath);
        this.props.history.push(newSubpath);
    }
    addNewEntity = (e) => {
        let options = queryString.parse(this.props.location.search);
        let whitelist = options.whitelistTags?.split(',');
        whitelist = whitelist.filter(x => !!x);
        this.props.sendMessage({
            operation: 'add new entity',
            tags: whitelist,
        });
    }
    confirmRemoveEntity = (e) => {
        let id = e.target.dataset.id;
        let name = e.target.dataset.name;
        if(window.confirm('Are you sure you want to permanently delete ' + name + '?')){
            this.removeEntity(id);
        }
    }
    removeEntity = (id) => {
        this.props.sendMessage({
            operation: 'remove entity',
            entityid: id,
        });
    }
    changeStat = (e) => {
        let entityid = e.target.dataset.entityid;
        let statid = e.target.dataset.statid;
        let statgroup = e.target.dataset.statgroup;
        let value = e.target.value;
        let valueType = e.target.dataset.valuetype;
        // console.log(valueType);
        this.props.sendMessage({
            operation: 'change entity stat value',
            entityid,
            statgroup,
            statid,
            value,
            valueType,
        });
    }
    changeName = (id, name) => {
        let entityid = id;
        let value = name;
        this.props.sendMessage({
            operation: 'change entity name',
            entityid,
            value,
        });
    }

    removeTag = (id, tagName) => {
        let entityid = id;
        let tag = tagName;
        this.props.sendMessage({
            operation: 'remove entity tag',
            entityid,
            tag,
        });
    }

    addTag = (id, tagName) => {
        let entityid = id;
        let tag = tagName;
        this.props.sendMessage({
            operation: 'add entity tag',
            entityid,
            tag,
        });
    }

    addItem = (id, itemid) => {
        let entityid = id;
        this.props.sendMessage({
            operation: 'add entity item',
            entityid,
            itemid,
        });
    }

    removeItem = (id, itemid) => {
        let entityid = id;
        this.props.sendMessage({
            operation: 'remove entity item',
            entityid,
            itemid,
        });
    }

    addLimit = (entityid, name, multiplier, limitid) => {
        this.props.sendMessage({
            operation: 'add entity limit',
            entityid,
            limitid,
            name,
            multiplier,
        });
    }

    removeLimit = (entityid, name, limitid) => {
        this.props.sendMessage({
            operation: 'remove entity limit',
            entityid,
            limitid,
            name,
        });
    }

    setAspects = (id, list) => {
        this.props.sendMessage({
            operation: 'set entity aspects',
            entityid: id,
            type: 'aspects',
            list,
            source: 'EntityListTab',
        })
    }
    setFlaws = (id, list) => {
        this.props.sendMessage({
            operation: 'set entity aspects',
            entityid: id,
            type: 'flaws',
            list,
        })
    }
    
    sortEntities = (e) => {
        const prop = e.target.dataset.prop;
        let reverse = false;
        if(this.state.entitySortProp === prop){
            reverse = !this.state.sortReverse;
        }
        this.setState({
            entitySortProp: prop,
            sortReverse: reverse,
        });
    }
    openTagSelector = (e) => {
        this.setState({
            tagSelector: true,
        })
    }
    changeTagOperation = (e) => {
        this.setState({
            operation: e.target.value
        })
    }
    changeTagLogic = (e) => {
        this.setState({
            logic: e.target.value
        })
    }
    changeColumnSort = (e, stat, group) => {
        console.log(e, stat, group)
        let sortColumn = stat.name;
        let sortTypeIndex = 0;
        if(sortColumn === this.state.columnSort ||
            this.state.columnSort == ''
        ) {
            // console.log('increment')
            sortTypeIndex = (this.state.colSortType + 1) % 5;
            if(sortTypeIndex === 0) sortColumn = '';
        }
        else {
            sortTypeIndex = 1;
        }
        this.setState({
            columnSort: sortColumn,
            colSortType: sortTypeIndex,
            colSortGroup: group,
        }, () => {
            // let colsort = {
            //     columnSort: sortColumn,
            //     colSortType: sortTypeIndex,
            //     colSortGroup: group,
            // }
            // this.pushHistory(e, colsort);
            this.pushHistory(e);
            // console.log(sortTypeIndex, sortColumn);
        });
    }
    filterEntities = (entities, options) => {
        // console.log(this.state.tagList)
        if(options['parent-op'] === 'doc') {
            entities = entities.filter(x => !x.external);
        }
        if(options['parent-op'] === 'parent') {
            entities = entities.filter(x => x.external);
        }
        let whitelist = options.whitelistTags?.split(',').filter(x => !!x) || [];
        let blacklist = options.blacklistTags?.split(',').filter(x => !!x) || [];
        if(whitelist.length > 0) {
            if(options['white-op'] === 'any') {
                entities = entities.filter(x => this.any(x.tags, whitelist))
            }
            if(options['white-op'] === 'all') {
                entities = entities.filter(x => this.all(x.tags, whitelist))
            }
        }
        if(blacklist.length > 0) {
            if(options['white-op'] === 'any') {
                entities = entities.filter(x => !this.any(x.tags, blacklist))
            }
            if(options['white-op'] === 'all') {
                entities = entities.filter(x => !this.all(x.tags, blacklist))
            }
        }
        // filter entities based on colsort
        let colName = this.state.columnSort;
        if(this.state.columnSort != '') {
            if(this.state.colSortType === 3 || this.state.colSortType === 4) {
                let group = this.state.colSortGroup;
                // console.log(group)
                entities = entities.filter(x => {
                    if(x[group].length === 0) return false;
                    return !!x[group].find(y => y.name === colName);
                });
            }
        }
        return entities;
    }
    any = (a, b) => {
        let success = false;
        b.forEach(x => {
            if(a.includes(x)) {
                return success = true;
            }
        })
        return success;
    }
    all = (a, b) => {
        let success = true;
        b.forEach(x => {
            if(!a.includes(x)) {
                return success = false;
            }
        })
        return success;
    }
    openModal = (e) => {
        let target = e.target.dataset.target;
        // console.log(target)
        this.setState({
            [target]: true,
        })
    }
    closeModal = (e) => {
        let target = e.target.dataset.target;
        this.setState({
            [target]: false,
            tagSelector: false,
        })
    }

    render() {
        let options = queryString.parse(this.props.location.search);
        if (!options) {
            options = {
                'parent-op': 'doc',
            }
        }
        let whitelistTags = options.whitelistTags?.split(',').map(x => x.trim()) || [];
        let blacklistTags = options.blacklistTags?.split(',').map(x => x.trim()) || [];
        let doc = this.props.doc;
        let entities = doc.entities || [];
        entities = this.filterEntities(entities, options);
        entities.sort(CompareProp(this.state.entitySortProp,
            this.state.sortReverse, true));
        
        // colsort
        if(!!this.state.columnSort && this.state.colSortType > 0) {
            // console.log('column sort', options.columnSort)
            let reverse = this.state.colSortType === 1 ||
                this.state.colSortType === 3;
            entities.sort(CompareStat(this.state.columnSort,
                this.state.colSortGroup, reverse, false));
        }

        // component setup
        let skillCount = {};
        this.skillGroups.forEach(skillGroup => skillCount[skillGroup] = 0);
        doc.skills?.forEach(skill => {
            skillCount[skill.skillGroup]++;
        })
        document.title = ['Entity List', doc.name, 'SGS'].join(' - ');
        // Sgs.calculateAllXp(doc);
        return(<div className='entity-table-wrapper'>
            <EntityTable
                doc = {doc}
                entities = {entities}
                skillCount = {skillCount}
                skillGroups = {this.skillGroups}
                sortEntities = {this.sortEntities}
                openModal = {this.openModal}
                addNewEntity = {this.addNewEntity}
                confirmRemoveEntity = {this.confirmRemoveEntity}
                removeTag = {this.removeTag}
                addTag = {this.addTag}
                removeLimit = {this.removeLimit}
                addLimit = {this.addLimit}
                // modifyLimit = {this.modifyLimit}
                setAspects = {this.setAspects}
                setFlaws = {this.setFlaws}
                changeStat = {this.changeStat}
                sendMessage = {this.props.sendMessage}
                addItem = {this.addItem}
                removeItem = {this.removeItem}
                changeName = {this.changeName}
                changeColumnSort = {this.changeColumnSort}
                sortColumn = {this.state.columnSort}
                sortType = {this.state.colSortType}
                sortGroup = {this.state.colSortGroup}
            />
            <EntityList
                doc = {doc}
                entities = {entities}
                skillCount = {skillCount}
            />
            <Modal
                state={this.state}
                title='Filter entities by Tag'
                target='tagModal'
                closeModal={this.closeModal}
                closeButtonText='close'
            >
                <h3>Parent Doc</h3>
                <select
                    id="parent-op"
                    onChange={this.pushHistory}
                    value={options['parent-op']}
                >
                    <option value='doc'>Doc only</option>
                    <option value='both'>Include both</option>
                    <option value='parent'>Parent only</option>
                </select>
                <h3>Whitelist Tags</h3>
                <select
                    id="white-op"
                    onChange={this.pushHistory}
                    value={options['white-op']}
                >
                    <option value='any'>Any of the following tags</option>
                    <option value='all'>All of the following tags</option>
                </select>
                <br />
                {doc.entityTags?.map((tag) => {return(
                    <label key={tag}>
                        {tag}
                        &nbsp;
                        <input
                            type='checkbox'
                            value={tag}
                            data-list='whitelist'
                            checked={whitelistTags.includes(tag)}
                            onChange={this.pushHistory}
                        />
                    </label>
                )})}
                <h3>Blacklist Tags</h3>
                <select
                    id="black-op"
                    onChange={this.pushHistory}
                    value={options['black-op']}
                >
                    <option value='any'>Any of the following tags</option>
                    <option value='all'>All of the following tags</option>
                </select>
                <br />
                {doc.entityTags?.map((tag) => {return(
                    <label key={tag}>
                        {tag}
                        &nbsp;
                        <input
                            type='checkbox'
                            value={tag}
                            data-list='blacklist'
                            checked={blacklistTags.includes(tag)}
                            onChange={this.pushHistory}
                        />
                    </label>
                )})}
            </Modal>
        </div>)
    }
}

export default withRouter(EntityListTab);